<template>
    <div>
        <!-- Step one -->
        <modal v-if="hasCancelled === false"
               @closed="close"
               class="text-center"
               :cancel-button-text="$t('CANCEL_SUBSCRIPTION_MODAL_KEEP_FLOWERS')">
            <h2>{{ $t('CANCEL_SUBSCRIPTION_MODAL_YOU_SURE') }} {{ address.address1 }} ?</h2>
            <p v-html="$t('CANCEL_SUBSCRIPTION_MODAL_DONT_WORRY')"></p>
            <p class="error" v-text="error"></p>
            <template slot="actions-prefix">
                <button
                    @click.prevent="cancelSubscription"
                    class="btn btn--primary mb-2 md:mb-0 md:ml-2">
                    {{$t('CANCEL_SUBSCRIPTION_MODAL_STOP_FLOWERS')}}
                </button>
            </template>
        </modal>

        <!-- Step two -->
        <modal v-if="hasCancelled === true"
               @closed="close"
               :cancel-button-text="$t('MODAL_UNDERSTOOD')"
               class="text-center">
            <h2>{{ $t('CANCEL_SUBSCRIPTION_MODAL_WE_CANCELLED') }} {{ address.address1 }}</h2>
            <div v-if="activeSubscriptionsAfterCancel.length === 1">
                <p>
                    {{ $t('CANCEL_SUBSCRIPTION_MODAL_STILL_RECEIVE') }}
                    {{ getAddressLine(activeSubscriptionsAfterCancel[0].delivery_address_id) }}
                </p>
            </div>
            <div v-else>
                <p v-text="$t('CANCEL_SUBSCRIPTION_MODAL_ADDRESS')"></p>
                <div class="mx-auto text-center">
                    <ul class="inline-block">
                        <li v-for="(subscription, index) in activeSubscriptionsAfterCancel"
                            :key="index">
                            <p v-text="getAddressLine(subscription.delivery_address_id)"></p>
                        </li>
                    </ul>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/structure/Modal';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

export default {
    name: 'CancelSubscriptionModal',
    data() {
        return {
            hasCancelled: false,
            error: null,
        };
    },
    props: {
        subscriptionId: {
            requires: true,
            type: Number,
        },
    },
    methods: {
        cancelSubscription() {
            let subscriptionService = new SubscriptionService();
            subscriptionService.cancelSubscription(this.subscriptionId)
                .then(() => {
                    this.hasCancelled = true;
                    this.$emit('cancelled', this.subscriptionId);
                })
                .catch(error => {
                    this.error = error || this.$t('CANCEL_SUB_MODAL');
                });
        },

        close() {
            if (this.hasCancelled === true) this.$store.dispatch('subscription/fetchAllSubscriptions', true);

            this.$emit('closed');
        },

        getAddressLine(addressId) {
            return this.$store.getters['address/getAddressById'](addressId).address1;
        },
    },
    computed: {
        activeSubscriptions() {
            return this.$store.getters['subscription/getActiveSubscriptions'];
        },

        activeSubscriptionsAfterCancel() {
            return this.activeSubscriptions
                .filter(subscription => subscription.id !== this.subscriptionId);
        },

        address() {
            return this.$store.getters['address/getAddressById'](this.subscription.delivery_address_id);
        },
        subscription() {
            return this.$store.getters['subscription/getSubscriptionById'](this.subscriptionId);
        },
    },
    components: {
        Modal,
    },
};
</script>
